import UserInfo from "@/app/types/UserInfo";
import {NEXT_SITE_URL} from "@/app/util/urlUtils";

/**
 * Fetch the UserInfo object based on the user's current `platsessionid` cookie.
 * @returns A UserInfo object corresponding to the user's session if it's valid.
 *          Otherwise returns null.
 */
export const fetchUserInfoClient = async () => {
	const userInfoResponse = await fetch(`${NEXT_SITE_URL}/get-user-info`, {
		credentials: "include",
	});
	try {
		const userInfo = await userInfoResponse.json();
		// no seriously typing these is going to be the worst part of everything
		return userInfo as UserInfo | null;
	} catch (err) {
		console.warn("An error occurred while fetching user info.");
		return null;
	}
};
